import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { OrderFieldConfigMap } from 'src/app/module/order/interface/order-field.interface';
import { PropertyFieldConfigMap } from 'src/app/module/property/interface/property.interface';
import { API_ACTION, API_SCOPE, ApiAction, ApiScope } from 'src/app/shared/interceptor/interceptor.token';
import { AppEnumMap, CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { environment as ENV } from 'src/environments/environment';

interface FrontendConfigApiResponse {
  propertyField: PropertyFieldConfigMap;
  orderField?: OrderFieldConfigMap | null;
}

export interface FieldConfigs {
  propertyField: PropertyFieldConfigMap;
  orderField: OrderFieldConfigMap;
}

@Injectable({
  providedIn: 'root',
})
export class FrontendConfigApi {
  constructor(
    private _http: HttpClient,
    private _snackBarService: SnackBarService
  ) {}

  /** Loads the property and order field configs together, in a single request. */
  getFieldConfigs(reportType?: string): Observable<FieldConfigs> {
    let params = new HttpParams().append('type', 'propertyField').append('type', 'orderField');
    if (reportType) params = params.set('reportType', reportType);

    return this._http
      .get<CommonApiResponse<FrontendConfigApiResponse>>(`${ENV.backendBaseUrl}/api/getFrontendConfig`, {
        params,
        context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.COMPANY),
      })
      .pipe(
        map((res) => ({ propertyField: res.data.propertyField, orderField: res.data.orderField ?? {} })),
        catchError((error: Error) => {
          this._snackBarService.open('error', 'Failed to load field configuration.');
          return throwError(() => error);
        })
      );
  }

  getEnumeration(reportType?: string): Observable<AppEnumMap> {
    const params: Record<string, string> = {};
    if (reportType) params['reportType'] = reportType;

    return this._http
      .get<
        CommonApiResponse<AppEnumMap>
      >(`${ENV.backendBaseUrl}/api/getAllEnumerations`, { params, context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.COMPANY) })
      .pipe(map((res) => res.data));
  }
}
